<section class="page-hero">
  <div class="page-title-block">
    <div class="page-eyebrow">
      <mat-icon>receipt_long</mat-icon>
      <span>Operaciones</span>
    </div>
    <h1>{{ title }}</h1>
    <p>{{ subtitle }}</p>
  </div>

  <div class="page-hero-actions">
    <div class="hero-stat-card muted">
      <span class="hero-stat-label">Resultados</span>
      <strong>{{ resultCount }}</strong>
    </div>
    <div class="hero-stat-card muted">
      <span class="hero-stat-label">Cargadas</span>
      <strong>{{ loadedCount }}</strong>
      <span class="hero-stat-hint" *ngIf="isLoadingMore">cargando…</span>
    </div>
    <div class="hero-stat-card muted">
      <span class="hero-stat-label">Filtros activos</span>
      <strong>{{ activeFilterCount }}</strong>
    </div>
    <button
      type="button"
      mat-raised-button
      class="btn-hero-refresh"
      (click)="refresh.emit()"
      [disabled]="isLoading && loadedCount === 0"
    >
      <mat-icon>refresh</mat-icon>
      Actualizar
    </button>
  </div>
</section>
